import { defineKey as T } from '@ha/intl';
import { UtilityBills, UtilityBillsValues } from '../Listing/types';

export const UtilityBillsLabelByValue: Record<UtilityBills, string> = {
  [UtilityBillsValues.INCLUDED]: T('Bills Included'),
  [UtilityBillsValues.EXCLUDED]: T('Bills Excluded'),
  [UtilityBillsValues.PARTIALLY]: T('Some Bills Included'),
};
